import React from "react";

import { ProjectEdition } from "./projectEdition";
import { Props } from "./types";

function ProjectDuplication({ zone, sourceProject, close }: Props) {
  const [selectedZone, setSelectedZone] = React.useState(zone || null);

  return (
    <ProjectEdition
      zone={selectedZone}
      sourceProject={sourceProject}
      isMultiProject={true}
      close={close}
      selectZone={setSelectedZone}
    />
  );
}

export { ProjectDuplication };
